module.exports = __webpack_public_path__ + "img/kleisma2m-m@2.d0a492a5.webp";